// extracted by mini-css-extract-plugin
export default {"superAdmin":"SuperAdmin_superAdmin__TKZS7","table":"SuperAdmin_table__ozRRQ","deleteButton":"SuperAdmin_deleteButton__omSre"};